// ─────────────────────────────────────────────────────────────────────────────
// DYNAMIC PAGE — nav sticky con smooth scroll e scroll-spy
// ─────────────────────────────────────────────────────────────────────────────
function initDynamicPageNav() {
    const nav = document.getElementById('dpSectionNav');
    if (!nav) {
        return null;
    }

    const links = nav.querySelectorAll('a[data-section]');

    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.getElementById(this.getAttribute('data-section'));
            if (target) {
                const top = target.getBoundingClientRect().top + window.scrollY - 110;
                window.scrollTo({top: top, behavior: 'smooth'});
            }
        });
    });

    const sections = document.querySelectorAll('#dpSectionContent .dynamic-page__section-item');
    if (!sections.length) {
        return null;
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                links.forEach(function (l) {
                    l.classList.remove('is-active');
                });
                const active = nav.querySelector('a[data-section="' + id + '"]');
                if (active) {
                    active.classList.add('is-active');
                }
            }
        });
    }, {rootMargin: '-100px 0px -60% 0px', threshold: 0});

    sections.forEach(function (s) {
        observer.observe(s);
    });
}

export {initDynamicPageNav};
